<div class="card border border-secondary mb-3">
  <div class="card-content px-3">
    <div class="row">
      <div class="col-lg-5">
        <h5 class="mt-lg-1 mt-0 mb-lg-0 mb-4 font-weight-bold text-primary">
          {{ 'voucher.title' | translate }}
        </h5>
      </div>
      <div class="col-lg-4">
        <span class="input-group">
          <input
            type="text"
            [(ngModel)]="voucherCode"
            placeholder="INSERT CODE HERE"
            class="form-control text-center border-secondary ps-5 px-lg-0"
            (keyup.enter)="redeemVoucher()"
          />
          <div class="input-group-append">
            <button
              class="btn btn-secondary icon text-white font-weight-bold material-icons py-0"
              type="button"
              (click)="redeemVoucher()"
              [disabled]="disableButton"
            >
              arrow_forward_ios
            </button>
          </div>
        </span>
        <div class="text-center mt-1">
          <fgbcl-errors></fgbcl-errors>
        </div>

        <div class="result text-center" *ngIf="redemptionResult">
          <div class="font-size-10 font-praktika-bold mt-1" [ngClass]="redemptionResult === successMessage ? 'text-white' : ''">
            {{ redemptionResult }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
